import * as React from 'react';

import {AlertBox} from 'shells/alert-box/alert-box';
import {FormWrapperWithButtons} from 'shells/form/form-wrapper-with-buttons';

import {TemplateGroupPicker} from './template-group-picker';

type Props = {
    groups: any[];
    templateGroupId: string;
    onChange: (arg1: {id: string; name: string}) => void;
    onSave: () => Promise<any>;
    onClose: () => void;
};

export function ChangeGroupModal(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    return (
        // @ts-expect-error
        <AlertBox isOpen={true} onClose={props.onClose} closeButton={false}>
            <FormWrapperWithButtons
                title='Change template group'
                subtitle='Select a group to move this template to. This will move it for all users.'
                isSaving={isSaving}
                onCancel={props.onClose}
                onSaveClick={() => {
                    setIsSaving(true);
                    props.onSave().then(() => {
                        setIsSaving(false);
                        props.onClose();
                    });
                }}
                buttonText='Save'
                resetOnSaveComplete={true}
            >
                <TemplateGroupPicker
                    groups={props.groups}
                    templateGroupId={props.templateGroupId}
                    onChange={props.onChange}
                    styles={{
                        // @ts-expect-error
                        control: (provided) => ({
                            ...provided,
                            width: '448px',
                        }),
                    }}
                />
            </FormWrapperWithButtons>
        </AlertBox>
    );
}
